import { Injectable, Inject } from '@angular/core';
import { ConfigLoader } from '@airtradeit/authentication';

import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class AuthConfigLoaderService implements ConfigLoader {
  constructor(@Inject(ConfigService) private _configService: ConfigService) {}

  getWebApi(): string {
    return this._configService.getProperty<string>('WEB_API_URL');
  }
  getChannelCode(): string {
    return this._configService.getProperty<string>('CHANNEL_CODE');
  }
  getAppCode(): string {
    return this._configService.getProperty<string>('APP_CODE');
  }
  getAuthServer(): string {
    return this._configService.getProperty<string>('AUTH_SERVER');
  }
  getSessionClientId(): string {
    return this._configService.getProperty<string>('CLIENT_ID');
  }
  getAuthApi(): string {
    return this._configService.getProperty<string>('AUTH_API_URL');
  }
  getAuthGrantType(): string {
    return this._configService.getProperty<string>('AUTH_GRANT_TYPE');
  }
}
